import { isPlatformBrowser } from '@angular/common';
import { Directive, ElementRef, Input, AfterViewInit, Renderer2, SimpleChanges, OnChanges, Output, EventEmitter, Inject, PLATFORM_ID } from '@angular/core';

@Directive({
  selector: '[appBackgroundImage]'
})
export class BackgroundImageDirective implements AfterViewInit, OnChanges {

  @Input('appBackgroundImage') backgroundImage: string;
  @Input('maxRetry') maxRetry = 5;
  @Output() imageLoading: EventEmitter<boolean> = new EventEmitter();
  @Output() readyToDisplayImage: EventEmitter<boolean> = new EventEmitter();
  @Output() imageLoadError: EventEmitter<boolean> = new EventEmitter();

  state = false;
  retry = 0;
  scalingDuration = 1000;

  constructor(
    private el: ElementRef,
    @Inject(PLATFORM_ID) private platformId: object,
    private renderer: Renderer2) {
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.renderBackgroundImage(this.backgroundImage);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.backgroundImage.firstChange) {
      this.loadCoverBackground();
    } else {
      this.imageLoading.emit(true);
      this.renderBackgroundImage(changes.backgroundImage.currentValue);
      this.readyToDisplayImage.emit(true);
    }
  }

  async loadCoverBackground() {
    if (isPlatformBrowser(this.platformId)) {
      const image = new Image();
      this.imageLoading.emit(true);
      image.onload = (event) => {
        this.state = true;
        this.renderBackgroundImage(this.backgroundImage);
        this.readyToDisplayImage.emit(true);
      };
      image.onerror = (event) => {
        // retry
        if (this.retry < this.maxRetry) {
          setTimeout(() => {
            this.retry++;
            this.loadCoverBackground();
          }, this.retry * this.scalingDuration);
        } else {
          this.imageLoadError.emit(true)
        }
      }
      image.src = this.backgroundImage;
    }
  }

  private renderBackgroundImage(image: string) {
    const regexp = /^(http|https):\/\/|(assets\/.+)$/;
    const prefix = regexp.test(image) ? '' : '//';
    this.renderer.setStyle(this.el.nativeElement, 'background-image', 'url(' + prefix + image + ')');
  }

}
